import { BasePlugin } from '../base'
import mdcRipple from './mdc-ripple.vue'

export * from './mdc-ripple-base.js'

export { mdcRipple }

export default BasePlugin({
  mdcRipple
})
